import { Box, styled } from '@mui/system';

export const Container = styled(Box)({
  margin: '20px 0',
  '.follow-up-status-chip': {
    display: 'inline-flex'
  }
});

export const FeedbackButton = styled('button')({
  background: 'none',
  border: 'none',
  padding: 0,
  color: '#0675DD',
  cursor: 'pointer',
  textAlign: 'left'
});

export const SurveyRating = styled('div')((props: { score: number }) => {
  let color;
  const rating = Number(props.score);

  if (rating >= 80) {
    color = 'green';
  } else if (rating >= 60) {
    color = '#fabe28';
  } else {
    color = 'red';
  }

  return {
    fontWeight: 500,
    color
  };
});
